import { AnyAction, CombinedState, combineReducers, Reducer } from "redux";

import authReducer from "./reducer/auth";
import clubReducer from "./reducer/club";
import productReducer from "./reducer/product";
import userReducer from "./reducer/user";
import courtReducer from "./reducer/court";
import bookingReducer from "./reducer/booking";
import branchReducer from "./reducer/branch";
import globalReducer from "./reducer/app";
import categoryReducer from "./reducer/category";

import { RootState } from "../types";

const appReducer: Reducer<
  CombinedState<RootState>,
  AnyAction
> = combineReducers<RootState>({
  authState: authReducer,
  clubState: clubReducer,
  productState: productReducer,
  categoryState: categoryReducer,
  userState: userReducer,
  courtState: courtReducer,
  bookingState: bookingReducer,
  branchState: branchReducer,
  appState: globalReducer,
});

// eslint-disable-next-line
const rootReducer = (state: any, action: any): any => {
  // if (action.type === "auth/LOGOUT_USER_REQUEST") {
  //   // eslint-disable-next-line no-param-reassign
  //   state = undefined;
  // }
  return appReducer(state, action);
};

export default rootReducer;
